export class WorklogAccordion {
    time: string;
    description: string;
    task: string;
}
